/* ATELIER — one reconciler for every configured free-gift rule. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;

  var CFG = window.AT_GIFT_PROMOTIONS || { rules: [], allProps: ['_free_gift', '_free_gift_2'] };
  var ALL_PROPS = CFG.allProps || ['_free_gift', '_free_gift_2'];
  var RULES = (CFG.rules || []).filter(function (rule) {
    return rule.enabled && Number(rule.variantId) > 0;
  }).map(function (rule) {
    rule.variantId = Number(rule.variantId);
    rule.minSubtotal = Number(rule.minSubtotal) || 0;
    return rule;
  });
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var queued = false;
  var queuedSilent = true;
  var debounceTimer;
  var verifyTimers = [];
  var scheduledUserAdd = false;
  var pendingAddProduct = '';
  var lastKnownItemCount = Number((document.querySelector('.cart-bubble__text-count') || {}).textContent) || 0;

  function hasGiftProp(item, prop) {
    return !!(item && item.properties && item.properties[prop]);
  }
  function isAnyGift(item) {
    for (var i = 0; i < ALL_PROPS.length; i++) if (hasGiftProp(item, ALL_PROPS[i])) return true;
    return false;
  }
  // The single source of cart eligibility data. Every rule and progress meter consumes it.
  function paidMetrics(cart) {
    var subtotal = 0;
    var quantity = 0;
    (cart.items || []).forEach(function (item) {
      if (isAnyGift(item)) return;
      subtotal += Number(item.final_line_price) || 0;
      quantity += Number(item.quantity) || 0;
    });
    return { paidSubtotal: subtotal, paidQty: quantity };
  }
  function activeRule(prop) {
    for (var i = 0; i < RULES.length; i++) if (RULES[i].prop === prop) return RULES[i];
    return null;
  }
  function correctionFor(cart) {
    var items = cart.items || [];
    var metrics = paidMetrics(cart);
    var i;
    // Orphans from disabled/unconfigured promotions are swept first.
    for (i = 0; i < items.length; i++) {
      for (var p = 0; p < ALL_PROPS.length; p++) {
        if (hasGiftProp(items[i], ALL_PROPS[p]) && !activeRule(ALL_PROPS[p])) {
          return { type: 'change', key: items[i].key, quantity: 0, reason: 'orphan' };
        }
      }
    }
    // Migrate legacy carts: the original automation identified its line only by variant ID.
    var legacy = RULES.filter(function (rule) { return rule.legacyVariant; });
    for (i = 0; i < items.length; i++) {
      if (isAnyGift(items[i])) continue;
      for (var l = 0; l < legacy.length; l++) {
        if (Number(items[i].variant_id || items[i].id) === legacy[l].variantId) {
          return { type: 'change', key: items[i].key, quantity: 0, reason: 'legacy' };
        }
      }
    }
    for (var r = 0; r < RULES.length; r++) {
      var rule = RULES[r];
      var lines = items.filter(function (item) { return hasGiftProp(item, rule.prop); });
      var qualifies = metrics.paidQty > 0 && metrics.paidSubtotal >= rule.minSubtotal;
      for (i = 0; i < lines.length; i++) {
        if (Number(lines[i].variant_id || lines[i].id) !== rule.variantId) {
          return { type: 'change', key: lines[i].key, quantity: 0, reason: 'stale' };
        }
      }
      if (!qualifies && lines.length) return { type: 'change', key: lines[0].key, quantity: 0, reason: 'unqualified' };
      if (qualifies && lines.length > 1) return { type: 'change', key: lines[1].key, quantity: 0, reason: 'duplicate' };
      if (qualifies && lines.length === 1 && Number(lines[0].quantity) !== 1) {
        return { type: 'change', key: lines[0].key, quantity: 1, reason: 'quantity' };
      }
      if (qualifies && !lines.length) return { type: 'add', rule: rule, reason: 'missing' };
    }
    return null;
  }
  function desiredItemCount(cart) {
    var metrics = paidMetrics(cart);
    var count = metrics.paidQty;
    RULES.forEach(function (rule) {
      if (metrics.paidQty > 0 && metrics.paidSubtotal >= rule.minSubtotal) count += 1;
    });
    return count;
  }
  function cartSections() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) < 0) ids.push(id);
    });
    return ids;
  }
  function fetchJSON(url, options) {
    return nativeFetch(url, options).then(function (response) {
      if (!response.ok) {
        var error = new Error('Cart request failed: ' + response.status);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }
  function readCart() {
    return fetchJSON('/cart.js', { cache: 'no-store', credentials: 'same-origin' });
  }
  function applyCorrection(correction) {
    var sections = cartSections();
    var body = { sections: sections.join(','), sections_url: window.location.pathname };
    if (correction.type === 'add') {
      var properties = {};
      properties[correction.rule.prop] = 'true';
      body.items = [{ id: correction.rule.variantId, quantity: 1, properties: properties }];
      return fetchJSON('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      });
    }
    body.id = correction.key;
    body.quantity = correction.quantity;
    return fetchJSON('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    });
  }
  function dispatchThemeCartEvent(cart, sections) {
    var event = new Event('shopify:cart:lines-update', { bubbles: true });
    event.action = 'update';
    event.__atGift = true;
    event.promise = Promise.resolve({
      cart: { totalQuantity: cart.item_count },
      detail: { sections: sections || {}, items: cart.items, itemCount: cart.item_count, source: 'cart-items-component', atGift: true }
    });
    document.dispatchEvent(event);
  }
  function cleanGiftRows(cart) {
    var keys = {};
    (cart.items || []).forEach(function (item) { if (isAnyGift(item)) keys[item.key] = true; });
    document.querySelectorAll('.cart-items__gift[data-key]').forEach(function (row) {
      if (!keys[row.getAttribute('data-key')]) row.remove();
    });
  }
  function syncCartIndicators(cart) {
    var count = Number(cart.item_count) || 0;
    lastKnownItemCount = count;
    document.querySelectorAll('cart-icon').forEach(function (icon) {
      if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count, false);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble__text-count, [ref="cartItemCount"]').forEach(function (node) {
      node.textContent = count < 100 ? String(count) : '';
      node.classList.toggle('hidden', count === 0);
    });
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (_) {}
  }
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    function number(decimals, thousands, decimal) {
      var value = (Number(cents || 0) / 100).toFixed(decimals).split('.');
      value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return value[0] + (value[1] ? decimal + value[1] : '');
    }
    return format.replace(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?)\s*\}\}/, function (_, token) {
      if (token === 'amount_no_decimals') return number(0, ',', '.');
      if (token === 'amount_with_comma_separator') return number(2, '.', ',');
      if (token === 'amount_no_decimals_with_comma_separator') return number(0, '.', ',');
      if (token === 'amount_with_apostrophe_separator') return number(2, "'", '.');
      return number(2, ',', '.');
    });
  }
  function updateProgress(metrics) {
    var rule = activeRule('_free_gift_2');
    document.querySelectorAll('[data-at-gift-progress]').forEach(function (el) {
      if (!rule) { el.hidden = true; return; }
      el.hidden = false;
      var unlocked = metrics.paidQty > 0 && metrics.paidSubtotal >= rule.minSubtotal;
      var percent = unlocked ? 100 : Math.min(99, Math.floor((metrics.paidSubtotal / rule.minSubtotal) * 100));
      var previous = el.getAttribute('data-unlocked') === 'true';
      var fill = el.querySelector('[data-at-gift-progress-fill]');
      var text = el.querySelector('[data-at-gift-progress-text]');
      if (fill) fill.style.width = percent + '%';
      if (text) text.textContent = unlocked ? 'Unlocked. A free ' + rule.title + ' is in your cart.' :
        formatMoney(Math.max(0, rule.minSubtotal - metrics.paidSubtotal), CFG.moneyFormat) + ' away from a free ' + rule.title + '.';
      el.setAttribute('data-unlocked', String(unlocked));
      el.setAttribute('aria-valuenow', String(Math.min(metrics.paidSubtotal, rule.minSubtotal)));
      el.setAttribute('aria-valuemax', String(rule.minSubtotal));
      if (el.__atProgressReady && previous !== unlocked) {
        el.classList.add('at-gift-progress--crossing');
        setTimeout(function () { el.classList.remove('at-gift-progress--crossing'); }, 500);
      }
      if (!el.__atProgressReady) requestAnimationFrame(function () { el.__atProgressReady = true; el.classList.add('at-gift-progress--ready'); });
    });
  }
  function broadcast(cart, addedNames) {
    var metrics = paidMetrics(cart);
    syncCartIndicators({ item_count: desiredItemCount(cart) });
    updateProgress(metrics);
    cleanGiftRows(cart);
    document.dispatchEvent(new CustomEvent('at:gift-cart-state', {
      detail: { cart: cart, paidSubtotal: metrics.paidSubtotal, paidQty: metrics.paidQty, rules: RULES, addedGifts: addedNames || [], atGift: true }
    }));
  }
  function reconcile(options) {
    options = options || {};
    if (busy) { queued = true; queuedSilent = queuedSilent && !!options.silent; return Promise.resolve(); }
    busy = true;
    document.documentElement.classList.add('at-gift-syncing');
    document.querySelectorAll('cart-icon').forEach(function (icon) { icon.setAttribute('aria-busy', 'true'); });
    var addedNames = [];
    function pass(number, cart) {
      broadcast(cart, []);
      var correction = correctionFor(cart);
      if (!correction || number >= 8) return Promise.resolve(cart);
      return applyCorrection(correction).then(function (mutationCart) {
        if (correction.type === 'add' && addedNames.indexOf(correction.rule.title) < 0) addedNames.push(correction.rule.title);
        return readCart().then(function (fresh) {
          dispatchThemeCartEvent(fresh, mutationCart.sections);
          return pass(number + 1, fresh);
        });
      });
    }
    return readCart().then(function (cart) { return pass(0, cart); }).then(function (cart) {
      broadcast(cart, addedNames);
      if (!options.silent && (addedNames.length || options.userAdd || pendingAddProduct)) announceGifts(addedNames);
    }).catch(function (error) {
      if (!error || !(error.status >= 400 && error.status < 500)) console.warn('[free-gift]', error);
    }).then(function () {
      busy = false;
      if (queued) {
        var silent = queuedSilent;
        queued = false;
        queuedSilent = true;
        return reconcile({ silent: silent });
      }
      document.documentElement.classList.remove('at-gift-syncing');
      document.querySelectorAll('cart-icon').forEach(function (icon) { icon.removeAttribute('aria-busy'); });
    });
  }
  var toastHost;
  var activeAddToast;
  var toastDismissTimer;
  function ensureToastHost() {
    if (toastHost) return toastHost;
    toastHost = document.createElement('div');
    toastHost.className = 'at-toast-host';
    toastHost.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastHost);
    return toastHost;
  }
  function showToast(message, title, iconType) {
    var host = ensureToastHost();
    var toast = document.createElement('div');
    toast.className = 'at-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-atomic', 'true');
    toast.innerHTML = '<span class="at-toast__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      (iconType === 'cart' ? '<path d="M6 8h12l-1 11a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1L6 8z"></path><path d="M9 8V6.5a3 3 0 0 1 6 0V8"></path>' : '<path d="M20 12v9H4v-9"></path><path d="M2 7h20v5H2z"></path><path d="M12 22V7"></path><path d="M12 7S9 3 6.5 4.5 8 7 12 7z"></path><path d="M12 7s3-4 5.5-2.5S16 7 12 7z"></path>') +
      '</svg></span><span class="at-toast__body"><span class="at-toast__title"></span><span class="at-toast__msg"></span><ul class="at-toast__gifts" hidden></ul></span><button class="at-toast__close" type="button" aria-label="Dismiss notification">×</button>';
    toast.querySelector('.at-toast__title').textContent = title;
    toast.querySelector('.at-toast__msg').textContent = message;
    host.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-in'); });
    function dismiss() {
      toast.classList.remove('is-in');
      if (activeAddToast && activeAddToast.toast === toast) activeAddToast = null;
      setTimeout(function () { toast.remove(); }, 300);
    }
    toast.querySelector('.at-toast__close').addEventListener('click', dismiss);
    toast.dismiss = dismiss;
    toastDismissTimer = setTimeout(dismiss, 4800);
    return toast;
  }
  function announceGifts(names) {
    names = names.filter(function (name, index) { return names.indexOf(name) === index; });
    if (names.length) document.dispatchEvent(new CustomEvent('at:gifts-added', { detail: { gifts: names, giftTitle: names[0], atGift: true } }));
    if (activeAddToast) {
      clearTimeout(toastDismissTimer);
      activeAddToast.toast.classList.remove('at-toast--loading');
      activeAddToast.toast.removeAttribute('aria-busy');
      activeAddToast.title.textContent = names.length ? 'Added with ' + names.length + (names.length === 1 ? ' free gift' : ' free gifts') : 'Added to cart';
      activeAddToast.message.textContent = pendingAddProduct ? pendingAddProduct + ' is in your cart.' : 'Your cart is up to date.';
      activeAddToast.gifts.replaceChildren();
      names.forEach(function (name) {
        var item = document.createElement('li');
        item.textContent = 'Free ' + name;
        activeAddToast.gifts.appendChild(item);
      });
      activeAddToast.gifts.hidden = names.length === 0;
      var settledToast = activeAddToast.toast;
      pendingAddProduct = '';
      toastDismissTimer = setTimeout(function () { settledToast.dismiss(); }, 5200);
      return;
    }
    if (names.length) showToast(names.join(', '), names.length === 1 ? 'Free gift added' : 'Free gifts added', 'gift');
  }
  function showAddedToast(data) {
    if (!data) return;
    var items = data.items && data.items.length ? data.items : [data];
    var paid = items.filter(function (item) { return item && !isAnyGift(item); });
    if (!paid.length) return;
    var addedQuantity = paid.reduce(function (total, item) { return total + (Number(item.quantity) || 0); }, 0);
    syncCartIndicators({ item_count: lastKnownItemCount + addedQuantity });
    pendingAddProduct = (paid[0].product_title || paid[0].title || 'Item') + (paid.length > 1 ? ' + ' + (paid.length - 1) + ' more' : '');
    if (activeAddToast && activeAddToast.toast) activeAddToast.toast.remove();
    clearTimeout(toastDismissTimer);
    var toast = showToast('Checking your free gifts…', 'Adding to cart', 'cart');
    clearTimeout(toastDismissTimer);
    toastDismissTimer = setTimeout(function () { toast.dismiss(); }, 10000);
    toast.classList.add('at-toast--loading');
    toast.setAttribute('aria-busy', 'true');
    activeAddToast = {
      toast: toast,
      title: toast.querySelector('.at-toast__title'),
      message: toast.querySelector('.at-toast__msg'),
      gifts: toast.querySelector('.at-toast__gifts')
    };
  }
  window.AtToast = showToast;
  function schedule(options) {
    options = options || {};
    scheduledUserAdd = scheduledUserAdd || !!options.userAdd;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var userAdd = scheduledUserAdd;
      scheduledUserAdd = false;
      reconcile({ silent: !!options.silent && !userAdd, userAdd: userAdd });
    }, options.delay != null ? options.delay : (options.immediate ? 20 : 150));
    verifyTimers.forEach(clearTimeout);
    verifyTimers = [1200, 3000].map(function (delay) { return setTimeout(function () { reconcile({ silent: true }); }, delay); });
  }
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/i;
  function installFetchHook() {
    var downstream = window.fetch;
    if (!downstream || downstream.__atGiftHook) return;
    function hooked(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var response = downstream.apply(this, arguments);
      if (CART_MUTATION.test(url)) response.then(function (res) {
        if (res && res.ok) {
          if (CART_ADD.test(url)) res.clone().json().then(showAddedToast).catch(function () {});
          schedule({ silent: false, userAdd: CART_ADD.test(url), immediate: CART_ADD.test(url) });
        }
      }, function () {});
      return response;
    }
    hooked.__atGiftHook = true;
    window.fetch = hooked;
  }
  function installXHRHook() {
    if (!window.XMLHttpRequest || XMLHttpRequest.prototype.__atGiftHook) return;
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) { this.__atGiftUrl = String(url || ''); return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (CART_MUTATION.test(this.__atGiftUrl || '')) this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) schedule({ silent: false });
      });
      return send.apply(this, arguments);
    };
    XMLHttpRequest.prototype.__atGiftHook = true;
  }
  function giftHandleFromLink(href) {
    var match = href && href.match(/\/products\/([^/?#]+)/i);
    return match ? match[1].toLowerCase() : '';
  }
  function scrubSearch() {
    var handles = (CFG.hiddenHandles || []).map(function (handle) { return (handle || '').toLowerCase(); }).filter(Boolean);
    if (!handles.length) return;
    document.querySelectorAll('.search-modal, predictive-search-component, [class*="predictive-search"], .predictive-search-results, product-recommendations, nav, [role="navigation"]').forEach(function (surface) {
      surface.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        if (handles.indexOf(giftHandleFromLink(link.getAttribute('href'))) < 0) return;
        (link.closest('.predictive-search-results__card, li, .resource-card, [class*="resource"], [class*="card"]') || link).remove();
      });
    });
  }
  function boot() {
    [0, 500, 1500, 3000, 6000].forEach(function (delay) { setTimeout(installFetchHook, delay); });
    installXHRHook();
    document.addEventListener('submit', function (event) {
      var form = event.target;
      // Fetch/XHR completion is the fast path. This delayed fallback covers native or
      // third-party form submissions without racing a still-pending add request.
      if (form && CART_ADD.test(form.action || '')) schedule({ silent: false, userAdd: true, delay: 3000 });
    }, true);
    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (event.__atGift || (event.detail && event.detail.atGift)) return;
      var afterUpdate = function () { schedule({ silent: false, userAdd: event.action === 'add', immediate: event.action === 'add' }); };
      if (event.promise && typeof event.promise.then === 'function') event.promise.then(afterUpdate, function () {});
      else afterUpdate();
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule({ silent: true }); });
    window.addEventListener('pageshow', function () { schedule({ silent: true }); });
    new MutationObserver(scrubSearch).observe(document.body, { childList: true, subtree: true });
    scrubSearch();
    reconcile({ silent: true });
  }
  window.AtGiftEngine = { paidMetrics: paidMetrics, correctionFor: correctionFor, reconcile: reconcile, formatMoney: formatMoney };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
